import { observer } from "mobx-react-lite";
import { context } from "..";
import Logo from "../misc/Logo";
import { Button } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import React from "react";


export default observer(function Header () {

    var params = useParams()
    var navigate = useNavigate()

    React.useEffect(() => {
        context.getAdvisorAccount(params.advisorUid).catch((response) => {
            navigate("/")
        })
    }, [])

    const saveAndQuit = async () => {
        console.log({...context.unsubmittedValues})
        if (context.unsubmittedValues) {
            await context.submitPageAnswers(context.unsubmittedValues, false)
        }
        context.logout()
    }

    if (!context.advisorAccount) return <header style={{boxShadow: "none"}}></header>

    return (
        <header>
            <div className="main-inner">
                {context.advisorAccount.logoUri 
                    ? <img src={context.advisorAccount.logoUri} alt="logo" height="40" />
                    : <Logo width={100} type="block" />}

                <div style={{display: "flex", gap: "10px"}}>
                    {context.token ? (
                        <>
                            <Button 
                                variant="contained"
                                className="btn btn-sm" 
                                onClick={() => saveAndQuit()}>
                                {context.locked ? "Quit" : "Save and Quit"}
                            </Button>
                        </>
                    ) : null}
                </div>
            </div>
        </header>
    )
})